import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    announcementId: Number
  }

  connect() {
    this.element.addEventListener("command", this.handleCommand)
  }

  disconnect() {
    this.element.removeEventListener("command", this.handleCommand)
  }

  handleCommand = (event) => {
    if (event.command === "show-modal") {
      this.markAsRead()
    }
  }

  markAsRead() {
    if (this.element.dataset.isRead !== "false") return

    const formData = new FormData()
    formData.append("announcement_id", this.announcementIdValue)
    formData.append("authenticity_token", document.querySelector('meta[name="csrf-token"]').content)

    fetch("/announcement_reads", { method: "POST", body: formData })
      .then(response => {
        if (response.ok) {
          this.element.dataset.isRead = "true"
        }
      })
      .catch(error => console.error("Error marking announcement as read:", error))
  }
}
